import { useI18n } from "@wojo/localization";
import { Markdown, Modal, ModalBody, ModalProps, Text } from "@wojo/ui";

export const WaitlistModal: React.FC<ModalProps> = (props) => {
    const l10n = useI18n("account").account;
    return (
        <Modal {...props}>
            <ModalBody>
                <Text.Heading
                    order="3"
                    tag="h1"
                    style={{
                        marginBottom: "var(--g-spacing-sm)",
                    }}
                >
                    {l10n.waitlistModal.title.l()}
                </Text.Heading>
                <Markdown markdown={l10n.waitlistModal.markdownBody.l()} />
            </ModalBody>
        </Modal>
    );
};
